<div class="row">
    <div [formGroup]="parentForm" [ngClass]="selectedCityST == '' ? 'col' : 'col-sm-8'">
        <!--<mat-form-field class="example-full-width" style="margin: 5px;" *ngIf="!isKendo">
        </mat-form-field>-->
        <div style="margin:5px;" *ngIf="isDisabled">
            <input type="text" style="margin:5px;" class="form-control" [value]="placeholder" disabled />
        </div>
        <div *ngIf="!isKendo && !isDisabled" style="margin:5px;">
            <input matInput #autoTrigger="matAutocompleteTrigger"
                   [placeholder]="placeholder"
                   [formControlName]="ctrlName"
                   [attr.aria-label]="ariaLabel"
                   [matAutocomplete]="city"
                   [required]="isRequired"
                   (keydown.enter)="$event.preventDefault(); chooseActiveCity($event)"
                   (keydown.Tab)="chooseActiveCity($event)"
                   (blur)="optionBlurred()"
                   class="form-control">
            <mat-autocomplete #city="matAutocomplete"
                              [displayWith]="displayCity"
                              (optionSelected)="optionChanged($event)"
                              (focusout)="optionBlurred()"
                              [panelWidth]="'400px'">
                <mat-option *ngFor="let city of filteredCities | async" [value]="city">
                    {{ isCityStateZip ? city.cityST + ' ' + city.zip : city.cityST }}
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="!isValid()">{{errorDetail}}</mat-error>
        </div>
        <div *ngIf="isKendo && !isDisabled">
            <!--https://www.telerik.com/kendo-angular-ui/components/dropdowns/autocomplete/filtering/-->
            <kendo-autocomplete [data]="cities"
                                [formControlName]="ctrlName"
                                valueField="cityST"
                                [filterable]="true"
                                (filterChange)="getCityLookup($event)"
                                (valueChange)="optionChanged($event)"
                                class="form-control"
                                placeholder="{{placeholder}}"
                                [required]="isRequired">
                <ng-template kendoAutoCompleteItemTemplate let-dataItem>
                    <div style="line-height:1.2;height:50px;">
                        <span *ngIf="isCityStateZip">{{dataItem.cityST}} {{dataItem.zip}}</span>
                        <span *ngIf="!isCityStateZip">{{dataItem.cityST}}</span>
                    </div>
                </ng-template>
            </kendo-autocomplete>
        </div>
    </div>
    <div class="col" *ngIf="!isChooseDefaultZip&&selectedCityST!=''">
        <select style="margin: 7px 0px 0px 0px;" name="cityID" class="form-select"
                [(ngModel)]="selectedCityID"
                (change)="cityZipChanged($event)"
                [disabled]="isDisabled">
            <option value="0">-- Select Zip --</option>
            <option *ngFor="let cityStateZip of cityStateZipList" value="{{cityStateZip.cityID}}">
                {{cityStateZip.zip}}
            </option>
        </select>
    </div>
</div>
<div class="row">
    <div class="col" *ngIf="timeZoneName != ''">
        <span><i class="fas fa-globe"></i> {{timeZoneName}}</span>
    </div>
    <div class="col" *ngIf="!isValidTimeZone">
        <div class="row">
            <div class="col">
                <span class="text-danger"><i class="fas fa-exclamation-circle"></i> Missing time zone</span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Lat</label>
                <input type="number" class="form-control" [(ngModel)]="cityLatitude" />
            </div>
            <div class="col">
                <label class="font-weight-bold">Lon</label>
                <input type="number" class="form-control" [(ngModel)]="cityLongitude" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                Enter the lat/lon values (get from a map) and save to update the time zone.
            </div>
            <div class="col">
                <button type="button" class="btn btn-primary" (click)="updateTimeZone()">Save</button>
            </div>
        </div>
    </div>
</div>
